import { Expose } from 'class-transformer'
import { Home } from '@material-ui/icons'

import { Base } from './Base'

export interface DaySpec {
  open: number
  close: number
}

export interface HoursOfOperation {
  mon?: DaySpec
  tue?: DaySpec
  wed?: DaySpec
  thu?: DaySpec
  fri?: DaySpec
  sat?: DaySpec
  sun?: DaySpec
  default: DaySpec
}

export type DayOfWeekKey = 'mon' | 'tue' | 'wed' | 'thu' | 'fri' | 'sat' | 'sun' | 'default'

export type ScheduledHoursOfOperation = { [date: string]: DaySpec }

export const defaultHoursOfOperation: HoursOfOperation = {
  sun: { open: 0, close: 0 },
  sat: { open: 0, close: 0 },
  default: { open: 8 * 60, close: 16 * 60 },
}

export class FacilitySchedule extends Base {
  static type = 'facilityschedule'
  static typeDisplay = 'Facility Schedule'
  static icon = Home

  type = FacilitySchedule.type
  typeDisplay = FacilitySchedule.typeDisplay
  icon = FacilitySchedule.icon

  @Expose({ name: 'max_inbound' })
  maxInbound: number = 0

  @Expose({ name: 'max_outbound' })
  maxOutbound: number = 0

  @Expose({ name: 'hours_of_operation' })
  hoursOfOperation: HoursOfOperation = { ...defaultHoursOfOperation }
}
